import React, { PropsWithChildren } from 'react';
import { Box, CircularProgress as MuiCircularProgress } from '@mui/material';
import { CircularProgressProps } from './types';

export const CircularProgress = ({
  thickness,
  value,
  size,
  children,
  backgroundStyle,
  ...restProps
}: PropsWithChildren<CircularProgressProps>) => (
  <Box display="inline-flex" justifyContent="center" alignItems="center" position="relative">
    <MuiCircularProgress
      variant="determinate"
      value={100}
      size={size}
      thickness={thickness}
      aria-hidden
      sx={{
        position: 'absolute',
        color: 'common.white',
        opacity: 0.2,
        ...backgroundStyle,
      }}
    />
    <MuiCircularProgress
      variant="determinate"
      value={value}
      size={size}
      thickness={thickness}
      sx={{ color: 'common.white' }}
      {...restProps}
    />
    <Box position="absolute" display="flex" justifyContent="center" alignItems="center">
      {children}
    </Box>
  </Box>
);
